import type { SVGProps } from "react";
export interface VrGlassesIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function VrGlassesIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: VrGlassesIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.602 7.948a1.126 1.126 0 0 1 .9 2.058l-.377.188v3.61l.378.19.101.057a1.125 1.125 0 0 1-1.002 2l-.105-.045-1-.5a1.13 1.13 0 0 1-.622-1.005V9.5c0-.426.242-.816.623-1.007l.999-.5zm18.9 8.058a1.125 1.125 0 0 1-1.005-2.012l1.006 2.012Zm-1.508-7.508a1.125 1.125 0 0 1 1.509-.504l1 .5c.381.19.621.58.622 1.006v5c0 .426-.24.816-.622 1.007l-1 .5L21 15l-.503-1.006.378-.19v-3.61l-.378-.188a1.125 1.125 0 0 1-.503-1.508"
      />
      <path
        fill={color}
        d="M9.627 15.54a3.126 3.126 0 0 1 4.746 0l.882 1.029c.166.194.41.306.665.306H18c1.035 0 1.875-.84 1.875-1.875V9c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v6c0 1.035.84 1.875 1.875 1.875h2.08a.88.88 0 0 0 .665-.306zM6.391 8.132A1.374 1.374 0 1 1 4.882 9.64l-.007-.14.007-.141A1.375 1.375 0 0 1 6.25 8.125zm3.5 0A1.375 1.375 0 1 1 8.38 9.64l-.006-.14.007-.141A1.375 1.375 0 0 1 9.75 8.125zM22.125 15A4.125 4.125 0 0 1 18 19.125h-2.08a3.13 3.13 0 0 1-2.137-.845l-.236-.246-.882-1.03a.876.876 0 0 0-1.33 0l-.882 1.03a3.13 3.13 0 0 1-2.373 1.091H6A4.125 4.125 0 0 1 1.875 15V9A4.125 4.125 0 0 1 6 4.875h12A4.125 4.125 0 0 1 22.125 9z"
      />
    </svg>
  );
}
